import register from '../../../../global/js/registry';
export default register('o-tabbed-content', () => import(/* webpackMode: "lazy" */ './o-tabbed-content.controller'));
